module.exports = __webpack_public_path__ + "img/angle-arrow-down.4593afdd.svg";